// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AuthenticationScriptStatusSchema = z.enum(['NONE','GENERATING','VALID','GENERATION_FAILED','VALIDATION_FAILED','NOT_VALID','NOT_SCRIPTABLE'] as const);

export type AuthenticationScriptStatusType = `${z.infer<typeof AuthenticationScriptStatusSchema>}`

export default AuthenticationScriptStatusSchema;
